import { render, staticRenderFns } from "./TrainingItemCustomerList.vue?vue&type=template&id=97c72ebc&scoped=true&"
import script from "./TrainingItemCustomerList.vue?vue&type=script&lang=js&"
export * from "./TrainingItemCustomerList.vue?vue&type=script&lang=js&"
import style0 from "./TrainingItemCustomerList.vue?vue&type=style&index=0&id=97c72ebc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97c72ebc",
  null
  
)

export default component.exports